import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SideNavBar = props => (
  <div
    className={`sidbr_container ${
      props.isComponentVisible ? 'mbl_active' : ''
    } cmn_box_shadow_x sidbar_mbl_vu`}
  >
    <div className="sidbar_mnu_container clr_bg_white">
      <ul>
        <li>
          <NavLink to="/skill-library" className="cmn_icon_txt">
            <FontAwesomeIcon icon={['fas', 'brain']} className="icon-sk_idea" />
            <span>Skill Library</span>
          </NavLink>
          <NavLink to="/test-library">
            <FontAwesomeIcon icon={['fas', 'books']} className="icon-sk_test" />
            <span>Test Library</span>
          </NavLink>
          <NavLink to="/traits">
            <FontAwesomeIcon
              icon={['fas', 'wand-magic-sparkles']}
              className="icon-sk_traits"
            />
            <span>Traits</span>
          </NavLink>
          <NavLink to="/content-admin">
            <FontAwesomeIcon
              icon={['fas', 'user-tie']}
              className="icon-user-tie"
            />
            <span>Content Admin</span>
          </NavLink>
        </li>
      </ul>
    </div>
  </div>
);

export default SideNavBar;
